import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faDownload, faEdit, faTrash,
} from '@fortawesome/pro-light-svg-icons'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'

import { Button, IconWithMenu, Link } from '@domain-group/suit-theme'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import { confirmAction, confirmDelete } from '@functions/entity'

import { generateUrls } from '@hooks/useCampaign'

import { CampaignModel, InvoiceModel } from '@models/types'

interface ControlProps {
  callbacks: {
    approveInvoice: () => void,
    deleteInvoice: () => void,
    showCreateOrEditInvoiceModal: (payload: { invoice: InvoiceModel }) => void,
  },
  campaign: CampaignModel,
  invoice: InvoiceModel,
  pdfDownloadUrl: string,
}

const Controls = (props: ControlProps) => {
  const {
    callbacks: {
      approveInvoice,
      deleteInvoice,
      showCreateOrEditInvoiceModal,
    },
    campaign,
    invoice,
    pdfDownloadUrl,
  } = props

  const { campaignAccountingUrl } = generateUrls(campaign)

  const navigateToAccountingDashboard = () => {
    window.location.href = campaignAccountingUrl
  }

  const confirmDeleteParams = {
    callbacks: {
      afterAction: navigateToAccountingDashboard,
      deleteFn: deleteInvoice,
    },
    strings: {
      deleteString: 'delete',
      entityName: 'Invoice',
    },
  }

  const confirmApproveParams = {
    callbacks: {
      actionFn: approveInvoice,
      afterAction: navigateToAccountingDashboard,
    },
    strings: {
      actionString: 'approve',
      entityName: 'Invoice',
    },
  }

  return (
    <>
      <IconWithMenu
        icon={(
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faCog} />}
            size="medium"
            style={{ height: 38 }}
          />
        )}
      >
        {/*
         // @ts-expect-error TS2741 */}
        <IconWithMenu.Menu closeOnClick listStyle={{ top: 'calc(100% + 12px)', right: '-7px' }}>
          {!invoice.approved && (
          <Link onClick={() => showCreateOrEditInvoiceModal({ invoice })}>
            <FontAwesomeIcon icon={faEdit} /> Edit Invoice
          </Link>
          )}

          {!invoice.approved && (
          // @ts-expect-error TS2345
          <Link onClick={() => confirmDelete(confirmDeleteParams)}>
            <FontAwesomeIcon icon={faTrash} /> Delete Invoice
          </Link>
          )}

          <AuthenticatedDownload key="download-pdf">
            <Link href={pdfDownloadUrl} target="blank" key="download">
              <FontAwesomeIcon icon={faDownload} /> Download Invoice
            </Link>
          </AuthenticatedDownload>
        </IconWithMenu.Menu>
      </IconWithMenu>

      {!invoice.approved && (
        <Button
          buttonStyle="primaryCreate"
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
          // @ts-expect-error
          marginLeft="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmAction(confirmApproveParams)}
          size="medium"
          width="auto"
          style={{ height: 38 }}
        >
          Approve
        </Button>
      )}
    </>
  )
}

export default Controls
